

















































import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
const typeMap = [
  ['business_type', '题型'],
  ['region_code', '地区'],
  ['year', '年份'],
  ['difficulty', '难度'],
  ['grade', '年级'],
  ['paper_type', '类型']
]

@Component({ components: { SmallBtnSkeleton } })
export default class SingleRowSelect extends Vue {
  @Prop() public data!: any
  @Prop({ type: String, default: 'normal' }) public size!: string
  @Prop() site!: any
  @Prop() subjectId!: string | number
  @Prop() logEvent!: string
  @Prop({
    type: Object,
    default() {
      return { name: '全部', val: 0 }
    }
  })
  selected!: any
  /**
   * clickItem
   */
  public mounted() {}
  public tempStr = ''
  public temp: any = {}
  public tempData: any = {}
  public flag: boolean = false

  public clickItem(itm: any, data: any) {
    this.tempStr = itm.name
    this.temp = itm
    this.tempData = data
    let obj: any = {
      name: itm.name,
      value: itm.val,
      group: data.name
    }
    let key = ''
    let group: any = ''
    this.onChoose(obj)
  }
  public judgeSelected(itm, temp) {
    return itm.val === temp.val
  }
  public switchIt(val: boolean) {
    this.flag = !this.flag
  }
  public siteShow(itm) {
    if (this.site && this.site[0] === 8) {
      return true
    } else {
      if (
        (~~this.subjectId === 101 && itm.name === '简答题') ||
        (~~this.subjectId === 102 && itm.name === '解答题')
      ) {
        return false
      } else {
        return true
      }
    }
  }
  public get reset() {
    return this.$store.state.reset
  }
  public get getFilters() {
    return this.$store.state.filters
  }
  @Emit()
  onChoose(val: any) {
    return val
  }
  @Watch('reset')
  onResetChange(val) {
    if (val) {
      this.tempStr = this.data.val[0].name
      this.temp = this.data.val[0]
      if (this.tempData.name === '来源：') {
        this.$store.commit('SET_RESET', false)
      }
    }
  }
  @Watch('data', { immediate: true, deep: true })
  onDataChange(val: any, old: any) {
    // console.log(val)
    this.tempStr = val.val[0].name
    if (this.selected.val) {
      this.temp = this.selected
    } else {
      this.temp = val.val[0]
    }
    this.tempData = val
    this.onChoose({
      name: this.temp.name,
      value: this.temp.val,
      group: this.tempData.name
    })
  }
  @Watch('selected', { deep: true })
  onSelected() {
    this.flag = true
  }
}
